<ng-container *transloco="let t">
  <section
    class="phone-brands full-width"
    [class.mobile]="(biggerThan$ | async)?.mobileL"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    @if (!(fetchingStartingPrices$ | async)) {
      <article class="content-wrapper">
        <!-- when brand or category set -->
        <ul class="grid">
          @for (brand of sortedBrandIndexes(); track brand) {
            <!-- BRAND -->
            @if ((brand.length || 0) > 1) {
              <div class="grid-item brand-item popsy-card">
                <!-- <h2 class="brand-label">{{ brand }}</h2> -->
                <app-brand-icon-picture
                  class="logo icon brand"
                  [pictureUrl]="getImageUrl(brand)"
                  [width]="'80px'"
                  [height]="'100px'"
                  [alt]="brand">
                </app-brand-icon-picture>
              </div>
            }
            <!-- ITEMS -->
            @for (product of sortedStartingPrices()[brand]; track product) {
              <app-product-model-item
                [product]="product.model"
                [price]="product.price"
                [category]="product.category"
                [imageUrl]="product.image"
                [id]="product.id"
                class="grid-item popsy-card"></app-product-model-item>
            }

            <div class="grid-break-line"></div>
          }
          <!-- ICONS -->
          @if (startingPrices(); as prices) {
            <div
              [class.first-icon]="(prices?.length || 0) >= 5"
              class="icon-item popsy-card">
              <popsy-icon-return-dark
                class="icon fill-secondary-light"></popsy-icon-return-dark>
              <span class="fixed-space-16" aria-hidden="true"></span>
              <span class="label"> {{ t('about_return_title') }} </span>
            </div>
            <div
              [class.second-icon]="(prices?.length || 0) >= 10"
              class="icon-item popsy-card">
              <popsy-icon-installments-dark
                class="icon fill-secondary-light"></popsy-icon-installments-dark>
              <span class="fixed-space-16" aria-hidden="true"></span>
              <span class="label">{{ t('label_installment_plan') }}</span>
            </div>
            <div
              [class.third-icon]="(prices?.length || 0) >= 15"
              class="icon-item popsy-card">
              <popsy-icon-warranty-dark
                class="icon fill-secondary-light"></popsy-icon-warranty-dark>
              <span class="fixed-space-16" aria-hidden="true"></span>
              <span class="label">
                {{ t('title_featured_warranty_variable', { var1: months }) }}</span
              >
            </div>
          }
        </ul>
      </article>
    }
  </section>
</ng-container>
